import { Injectable } from '@angular/core';
import { getSettings } from './settings.data';

@Injectable({
  providedIn: 'root',
})
export class SettingsService {
  readonly settings = getSettings();
}
